import React from "react";
import { ReviewItemProps } from "../../types/ReviewTypes";
import { useLocation, Link } from "react-router-dom";
import "./Review.css";
import TextBox from "../Common/TextBox";

const AlbumReviewItem: React.FC<ReviewItemProps> = ({ review, onEditReview }) => {
    const location = useLocation();
    const isAlbumReviewPage = location.pathname.startsWith('/review/album-');

    // Create content without edit button for the link version
    const reviewContentWithoutEdit = (
        <TextBox
            picture={review.picture}
            username={review.dubu_user}
            content={review.content}
            createdAt={review.created_at}
            updatedAt={review.updated_at}
            rating={Number(review.rating)}
            isOwner={false} // Don't show edit button in linked version
            defaultAvatar="/dubuFace.jpg"
            userId={Number(review.user_id)}
        />
    );

    // Create full content with edit button for non-linked version
    const reviewContentWithEdit = (
        <TextBox
            picture={review.picture}
            username={review.dubu_user}
            content={review.content}
            createdAt={review.created_at}
            updatedAt={review.updated_at}
            rating={Number(review.rating)}
            isOwner={review.is_owner}
            onEdit={() => onEditReview(review)}
            defaultAvatar="/dubuFace.jpg"
            userId={Number(review.user_id)}
        />
    );

    if (isAlbumReviewPage) {
        return reviewContentWithEdit;
    }

    // For non-review pages, render with Link but add edit button separately outside the Link
    return (
        <div className="review-item-wrapper">
            <Link to={`/review/album-${review.id}`} className="review-item-link">
                {reviewContentWithoutEdit}
            </Link>
            {/* Edit button outside the Link to prevent navigation conflict */}
            {review.is_owner && (
                <div className="review-edit-overlay">
                    <button
                        className="edit-review-button"
                        onClick={() => onEditReview(review)}
                        aria-label="Edit"
                    >
                        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </button>
                </div>
            )}
        </div>
    );
};

export default AlbumReviewItem; 